import React, { Component } from "react";
import { Link } from "react-router-dom";

class Breadcrumb extends Component{
    render(){
        const { title , subtitle, parent} = this.props;
        return(
            <React.Fragment>
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center">
                                    <div className="breadcrumb-inner pt--100">
                                        <h2 className="title">{title}</h2>
                                        <p>{subtitle}</p>
                                        <ul className="page-list">
                                            <li className="breadcrumb-item pt--15"><Link to={`${process.env.PUBLIC_URL}`}>Home</Link></li>
                                            {parent? <li className="breadcrumb-item">{parent}</li>:''}
                                            <li className="breadcrumb-item active">{title}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Breadcrumb;

